export const ERROR_CERTIFICATE = Object.freeze({
  emptyNumber: 'Введите номер сертификата',
  unCorrectNumber: 'Должно быть {maxLengthValue} символов',
  '0c70d86b-dd01-544d-8a90-ca793e7d09c9': 'Введите номер сертификата',
  '2f41df3e-6dd7-5861-90eb-6bff2b8ff95b': 'Сертификат с таким номером не найден',
  'bfa37727-4efc-59e5-bffb-31e7e8981ed7': 'Сертификат с таким номером не активен',
  '6c16db5e-02af-5d19-b024-3de0a0d546d2': 'Сертификат с таким номером уже был применен',
});

export const ERROR_PL_PROMO_CODES = Object.freeze({
  emptyNumber: 'Введите промокод',
  'f3b5b7a2-c7e7-4324-917b-b1fb9cb0fb26': 'Ошибка применения промокода',
  '3d27d5b8-e55d-4ecc-b0ee-54aaa248b279': 'Данное действие доступно только авторизированным пользователям',
  '7e04023e-d8fd-4c38-ad55-91a4a14de725': 'Указанный промокод не найден',
});

export const ERROR_LIVELIB = Object.freeze({
  'f6d4efd8-6dc2-4ab6-9287-8473394f625e': 'Не указан isbn',
  '8eb39047-a9e9-4af5-807e-bd4d3c9ae6c': 'Невозможно получить данные с Livelib.ru',
});

export const ERROR_CHECK_USER = Object.freeze({
  notStringPhone: 'Телефон должен быть строкой',
  emptyPhone: 'Телефон не должен быть пустым',
});

export const ERROR_CALL_ORDER = Object.freeze({
  notStringPhone: 'Телефон должен быть строкой',
  emptyPhone: 'Телефон не должен быть пустым',
  notStringCaptchaToken: 'CaptchaToken должен быть строкой',
  emptyCaptchaToken: 'CaptchaToken не должен быть пустым',
  notStringCaptchaAction: 'CaptchaAction должен быть строкой',
  emptyCaptchaAction: 'CaptchaAction не должен быть пустым',
});

export const ERROR_SALE_ORDER_ACTIVE = Object.freeze({
  '3d27d5b8-e55d-4ecc-b0ee-54aaa248b279': 'Данное действие доступно только авторизированным пользователям',
  '574815a1-4b64-4848-825b-5c0d86312bd7': 'Заказ не найден',
  '5fc70807-cf91-4299-b30c-aca6911bd1b9': 'Заказ не принадлежит пользователю',
  'c63159e8-6eea-497d-87e8-06b719e6faed': 'К сожалению, заказ уже невозможно изменить',
  '324de1bd-9a77-450b-8f43-3f413f7e005b': 'Ошибка пересчёта данных корзины',
  'e73221e5-bb00-4a05-9afb-85331d3fe154': 'Ошибка применения промокода',
  '20ab00f7-417d-4e23-a383-ae2728581789': 'Ошибка применения скидок в заказ',
  'd8599bae-cdbc-4caa-a223-325dd187ed28': 'У заказа нет применённых купонов',
  '2dbe5f15-b9ea-4677-9698-309993d64027': 'Товар уже есть в заказе, но в качестве подарка',
  'c54de475-32e3-464f-a3ce-3446f014ff87': 'В заказе уже есть подарок',
  'eceb4034-7500-4712-a64b-5ca5f5d6769e': 'С текущим составом заказа и примененными скидками заказ не может быть сохранен',
  'fbdb8e8d-303c-4650-b09b-9fd332b5b3a2': 'С текущим составом заказа и примененными скидками заказ не может быть сохранен',
});

export const ERROR_PROMOCODE_SALE_ORDER_ACTIVE = Object.freeze({
  'e73221e5-bb00-4a05-9afb-85331d3fe154': 'Ошибка применения промокода',
  '20ab00f7-417d-4e23-a383-ae2728581789': 'Ошибка применения скидок в заказ',
  'd8599bae-cdbc-4caa-a223-325dd187ed28': 'У заказа нет применённых купонов',
});

export const ERROR_USER_SESSION = Object.freeze({
  'ec375749-2357-46e3-a746-4a4c65d8d0cb': 'Неверный Email или пароль',
  '5395533f-ca4e-4f4d-bed4-a44656dcd60a': 'Ошибка проверки капчи',
});

export const ERROR_USER_APP_INSTALLED = Object.freeze({
  '3d27d5b8-e55d-4ecc-b0ee-54aaa248b279': 'Данное действие доступно только авторизированным пользователям',
});

export const ERROR_CODE_VERIFY_RECAPTCHA = '5395533f-ca4e-4f4d-bed4-a44656dcd60a';
export const ERROR_CODE_VERIFY_RECAPTCHA_STRING = '#e4kuot5et73d';

export const ERROR_CODE_REGISTRATION_EXIST_PHONE = 'b7bfe87d-f04b-4560-b102-5e94ee471e2e';

export const ERROR_CODE_EMAIL_YET_SUBSCRIBED = 'd984a965-2e8b-4873-8ac6-5eb24bd0de34';

export const ERROR_PHONE_TOO_LONG = '8c051f30-4799-43cd-ad77-2a780a5c4176';

export const ERROR_PHONE_INCORRECT = '3ddc6bb0-ecde-4183-af17-1a708bb0a158';

export const ERROR_CODE_TOO_MANY_TRIES_VERIFY_PHONE = 'c377ce9a-e67c-484a-a8b1-123184e05eb2';

